export default {
    buttons: {
        save: 'Сохранить',
        go_to_location: 'Перейти к местоположениям',
        change_password: 'Изменить пароль',
        change_email: 'Изменить email',
        eneter_email: 'Введите email',
        add_credentials: 'Добавить учетные данные',
        add_password: 'Добавить пароль',
        upload_profile_photo: 'Загрузить фото профиля',
        change_phone: 'Изменить номер телефона',
        enter_phone: 'Введите номер телефона',
        verify_phone: 'Подтвердить номер телефона',
        change: 'Изменить',
    },
    fields: {
        first_name: {
            label: 'Имя',
            placeholder: 'Иван',
        },
        last_name: {
            label: 'Фамилия',
            placeholder: 'Иванов',
        },
        username: {
            label: 'Имя пользователя',
            placeholder: 'Должно быть уникальным',
        },
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
        phone: {
            label: 'Номер телефона',
            placeholder: '+3811231231',
        },
        twitter: {
            label: 'X-Twitter',
            placeholder: 'Введите вашу ссылку на X-Twitter',
        },
        instagram: {
            label: 'Instagram',
            placeholder: 'Введите вашу ссылку на Instagram',
        },
        linkedin: {
            label: 'LinkedIn',
            placeholder: 'Введите вашу ссылку на LinkedIn',
        },
        facebook: {
            label: 'Facebook',
            placeholder: 'Введите вашу ссылку на Facebook',
        },
        description: {
            label: 'Описание',
            placeholder: 'Описание здесь...',
            description: 'Это общедоступная информация, которая будет показана при бронировании.',
        },
        tiktok: {
            label: 'Tik Tok',
            placeholder: 'Введите вашу ссылку на Tik Tok',
        },
        google: {
            label: 'Профиль компании в Google',
            placeholder: 'Введите URL вашего профиля компании в Google',
        },
    },
    messages: {
        confirm_email: 'Готово! Проверьте ваш email.',
        locations_not_set: 'У вас нет ни одного установленного местоположения. Хотите сделать это сейчас?',
        mobile_not_set: 'Мобильный телефон не указан. Хотите сделать это сейчас?',
        no_offers_active: 'У вас нет активных услуг.',
        no_offers_reneewal: 'У вас нет услуг для продления.',
        no_offers_expired: 'У вас нет истекших услуг.',
        no_favorite_offers: 'В настоящее время нет избранных услуг.',
    },
}
